import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Typeahead } from 'react-bootstrap-typeahead';
import EmailList from './emailList'
import http from '../services/httpService'
import _ from "lodash";

const apiCompany = 'companies';

class IntelPage extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.state.companies = [];
        this.state.filters = {};
    }

    async componentDidMount() {
        const { data: companies } = await http.get(apiCompany);
        this.setState(companies);
    }

    onCompanySelect = (company) =>  {
        const filters = {};
        if (company) {
            filters['companies'] = company['id'];
        }
        this.setState({ filters });
    }

    render() {
        const { user } = this.props;
        return (
            <React.Fragment>
                <h1 className="text-center text-ink mb-5">
                    { process.env.REACT_APP_APP_NAME + " Intel" }
                </h1>
                {user && <React.Fragment>
                    <div className="container">
                      <div className="row justify-content-center">
                        <Typeahead
                            id="company-intel-typeahead"
                            labelKey={ option => { return option.name } }
                            onChange={ ([selected]) => this.onCompanySelect(selected) }
                            options={this.state.companies}
                            placeholder="Get Company Intel"
                            className="col-12 col-lg-6"
                        />
                      </div>
                    </div>
                    <br />
                    <hr />
                    <br />
                    <EmailList
                        user={ user }
                        filters={ this.state.filters }
                        showAnalysis={ !_.isEmpty(this.state.filters)}
                        listSize={ 100 }
                    />
                </React.Fragment>}
                {!user && <div className="register-cta">
                Want access?&nbsp;
                  <Link className="text-rubyred" to="/register">
                    <strong>Register</strong>
                  </Link>
                &nbsp;now to get access to detailed marketing email metrics
                <img src="sendtime.jpg" />
              </div>}
            </React.Fragment>
        );
    }
}

export default IntelPage;
